<script lang="ts">
  import Brand from './Brand.svelte';
  let open = $state(false);
</script>
<header class="site-header sticky-top">
  <nav class="container d-flex align-items-center justify-content-between py-3">
    <Brand />
    <button class="btn d-lg-none menu-button" type="button" aria-label="Toggle navigation" onclick={() => open = !open}>☰</button>
    <div class:show={open} class="public-nav align-items-lg-center gap-lg-1">
      <a href="/packages" data-spa>Packages</a>
      <a href="/about" data-spa>About Bibow</a>
      <a href="/reviews" data-spa>Reviews</a>
      <a href="/book" data-spa class="btn btn-bibow ms-lg-2 px-4">Book your play day</a>
    </div>
  </nav>
</header>
